var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-br-angle-small-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2889 9.52497L11.612 4.93897C11.325 4.65771 10.9359 4.49975 10.5301 4.49985C10.1244 4.49994 9.73528 4.65808 9.44844 4.93947C9.16161 5.22087 9.00051 5.60247 9.00061 6.00033C9.00071 6.39819 9.16198 6.77971 9.44896 7.06097L14.1259 11.646C14.1734 11.6924 14.211 11.7476 14.2368 11.8083C14.2625 11.8691 14.2757 11.9342 14.2757 12C14.2757 12.0657 14.2625 12.1309 14.2368 12.1916C14.211 12.2524 14.1734 12.3075 14.1259 12.354L9.44896 16.939C9.16198 17.2202 9.00071 17.6018 9.00061 17.9996C9.00051 18.3975 9.16161 18.7791 9.44844 19.0605C9.73528 19.3419 10.1244 19.5 10.5301 19.5001C10.9359 19.5002 11.325 19.3422 11.612 19.061L16.2889 14.475C16.9572 13.8179 17.3324 12.9279 17.3324 12C17.3324 11.0721 16.9572 10.182 16.2889 9.52497Z",
    fill: "#545D5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngle);
export default __webpack_public_path__ + "static/media/angle.2cc438dcc23b42798e140bf308b9f492.svg";
export { ForwardRef as ReactComponent };